import {
  assertPopulated,
  assertPopulatedDeep,
} from '@dreamstack/payload/src/lib/assertPopulated'
import { RouterOutputs } from '@dreamstack/trpc/client'
import includes from 'lodash/includes'
import { useMemo } from 'react'
import { LEXICON_ENABLED } from '../config/featureflag.config'

const REAL_ESTATE_STATIC_PAGE_SLUGS = ['immobilien', 'real-estate']
const KNOWLEDGE_STATIC_PAGE_SLUGS = ['wissen', 'knowledge']

export const useNavbarDisplaySettings = (
  entry: Pick<
    RouterOutputs['cms']['getNavEntries'][number],
    'id' | 'label' | 'staticPage' | 'subEntries' | 'contentfulId'
  >
) => {
  assertPopulatedDeep(entry)
  const displaySettings = useMemo(() => {
    return {
      displayDefaultSubEntry:
        !includes(
          entry?.subEntries?.flatMap((i) => {
            assertPopulated(i)
            assertPopulated(i.staticPage)
            return i.staticPage?.slug
          }),
          entry.staticPage?.slug
        ) && entry?.staticPage?.slug !== 'my',
      displayProjectsSubEntry: REAL_ESTATE_STATIC_PAGE_SLUGS.includes(
        entry.staticPage?.slug ?? ''
      ),
      displayLexiconSubEntry:
        LEXICON_ENABLED &&
        KNOWLEDGE_STATIC_PAGE_SLUGS.includes(entry.staticPage?.slug ?? ''),
    }
  }, [entry])
  return displaySettings
}
